// Backend base URLs. Override per environment with REACT_APP_* vars;
// defaults point at locally-running services for development.
export const AUTH_API_URL = process.env.REACT_APP_AUTH_API_URL || 'http://localhost:3002';
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

// Public bucket base for org assets (logos). branding.logoKey is appended to this.
export const PUBLIC_ASSET_BASE =
  process.env.REACT_APP_PUBLIC_ASSET_BASE || 'https://range-drills.s3.us-east-2.amazonaws.com/';
